import * as Separator from "@radix-ui/react-separator";

import { cn } from "../../lib/utils";

export function Divider({
  className,
  label,
  orientation = "horizontal",
}: {
  className?: string;
  label?: string;
  orientation?: "horizontal" | "vertical";
}) {
  if (orientation === "vertical") {
    return (
      <Separator.Root
        decorative
        orientation="vertical"
        className={cn("h-full w-px bg-border", className)}
      />
    );
  }

  if (!label) {
    return (
      <Separator.Root
        decorative
        className={cn("h-px w-full bg-border", className)}
      />
    );
  }

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Separator.Root decorative className="h-px flex-1 bg-border" />
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
        {label}
      </span>
      <Separator.Root decorative className="h-px flex-1 bg-border" />
    </div>
  );
}
